import { DEFAULT_LOCALE, isSupportedLocale, resolveBrowserLocaleAlias, type SupportedLocale } from '../../../i18n/types'

export function pickInitialLocale(stored: string | null | undefined): SupportedLocale {
  if (isSupportedLocale(stored)) return stored

  const browserLang = typeof navigator !== 'undefined' && navigator.language ? navigator.language : DEFAULT_LOCALE

  if (isSupportedLocale(browserLang)) return browserLang

  const aliased = resolveBrowserLocaleAlias(browserLang)
  if (aliased) return aliased

  const baseLocale = browserLang.slice(0, 2).toLowerCase()
  if (isSupportedLocale(baseLocale)) return baseLocale
  return DEFAULT_LOCALE
}
